function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as i } from "./index.es33.js";
import { clsx as x } from "./index.es105.js";
import { Typography as a } from "./index.es35.js";
import "./index.es36.js";
import { Tooltip as m } from "./index.es13.js";
import { TooltipShorten as j } from "./index.es14.js";
import "./index.es15.js";
import { Link as h } from "./index.es42.js";
import s from "./index.es203.js";
var P = function P(_ref) {
  var r = _ref.label,
    l = _ref.tooltipAlternativePosition,
    c = _ref.withRequiredSign,
    e = _ref.optionalText,
    o = _ref.tooltipInfoText,
    t = _ref.infoText,
    n = _ref.link,
    d = _ref.isDisabled,
    p = _ref.color;
  return i.jsxs(a.Body2, {
    as: "div",
    className: x(s.container, _defineProperty({}, s.isDisabled, d)),
    color: p,
    children: [i.jsx(j, {
      title: r,
      children: r
    }), c && i.jsx("div", {
      className: s.requiredAsterisk,
      children: "*"
    }), e && i.jsx("div", {
      className: s.optionalText,
      children: e
    }), o && i.jsx("div", {
      className: s.tooltipContainer,
      children: i.jsx(m.Icon, {
        title: o,
        position: m.PositionVariants.underCenter,
        alternativePosition: l
      })
    }), i.jsxs("div", {
      className: s.rightSide,
      children: [t && i.jsx(a.Overline, {
        className: s.infoText,
        children: t
      }), n && i.jsx("div", {
        className: s.linkContainer,
        children: i.jsx(h, _objectSpread({}, n))
      })]
    })]
  });
};
export { P as Label };